module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17SEvlK/images/9780316216562.jpg?1733151126702",
      "alt": "This image is the cover for the book Complete Stories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Complete Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A \"lavishly entertaining\" ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(") distillation of Waugh's genius--abundant evidence that one of the twentieth century's most admired and enjoyed English novelists was also a master of the short form.")]), _c('br'), _vm._v("Evelyn Waugh's short fiction reveals in miniaturized perfection the elements that made him the greatest satirist of the twentieth century. The stories collected here range from delightfully barbed portraits of the British upper classes to an alternative ending to Waugh's novel"), _c('i', [_vm._v("A Handful of Dust;")]), _vm._v(" from a \"missing chapter\" in the life of Charles Ryder, the nostalgic hero of "), _c('i', [_vm._v("Brideshead Revisited, ")]), _vm._v("to a plot-packed morality tale that Waugh composed at a very tender age; from an epistolary lark in the voice of \"a young lady of leisure\" to a darkly comic tale of scandal in a remote (and imaginary) African outpost.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Evelyn Waugh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("&lt;DIV&gt;Evelyn Waugh (1903-1966), whom &lt;I&gt;Time&lt;/I&gt; called \"one of the century's great masters of English prose,\" wrote several widely acclaimed novels as well as volumes of biography, memoir, travel writing, and journalism. Three of his novels, &lt;I&gt;A Handful of Dust, Scoop, &lt;/I&gt;and&lt;I&gt; Brideshead Revisited,&lt;/I&gt; were selected by the Modern Library as among the 100 best novels of the twentieth century.&lt;/DIV&gt;")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0